import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Accordion } from 'components/atoms/Accordion/Accordion';
import './FAQItem.scss';
export function FAQItem({ className, content, type, iconType, preserve }) {
	return (
		<div className={classnames(className)}>
			<Accordion
				className={className}
				content={content}
				type={type}
				iconType={iconType}
				preserve={preserve}
			/>
		</div>
	);
}

FAQItem.propTypes = {
	className: PropTypes.string,
	content: PropTypes.arrayOf(PropTypes.object),
	type: PropTypes.string,
	iconType: PropTypes.string,
	preserve: PropTypes.bool,
};

export default FAQItem;
